// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + "login" + "." + "a7dc62b8" + ".chunk.css";
};